import { render } from "./confirmModal.vue?vue&type=template&id=4779c4f1"
import script from "./confirmModal.vue?vue&type=script&lang=js"
export * from "./confirmModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__